import React, { useState } from "react";

const PasswordChangeModal = ({
  isOpen,
  formData,
  onFormChange,
  onSubmit,
  onClose,
}) => {
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  if (!isOpen) return null;

  // Reusable eye icons (same as Login.js)
  const EyeOpenIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7
           -1.274 4.057-5.064 7-9.542 7
           -4.477 0-8.268-2.943-9.542-7z"
      />
    </svg>
  );

  const EyeOffIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M13.875 18.825A10.05 10.05 0 0112 19
           c-4.478 0-8.268-2.943-9.542-7
           a9.956 9.956 0 012.041-3.368M6.223 6.223
           A9.956 9.956 0 0112 5c4.478 0 8.268 2.943 9.542 7
           a9.978 9.978 0 01-4.132 5.411M15 12a3 3 0 00-3-3"
      />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3l18 18" />
    </svg>
  );

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        backdropFilter: "blur(4px)",
        WebkitBackdropFilter: "blur(4px)",
      }}
      // onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-8 animate-scale-in"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-display font-bold text-neutral-900">
            Cambiar Contraseña
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="text-neutral-400 hover:text-neutral-600 text-2xl leading-none"
            aria-label="Cerrar"
          >
            ✕
          </button>
        </div>

        <form onSubmit={onSubmit} className="space-y-4">
          {/* Current password */}
          <div>
            <label className="block text-sm font-medium text-neutral-700 mb-2">
              Contraseña Actual *
            </label>

            <div className="relative">
              <input
                type={showCurrentPassword ? "text" : "password"}
                value={formData.currentPassword}
                onChange={(e) =>
                  onFormChange({ ...formData, currentPassword: e.target.value })
                }
                required
                className="input-field pr-12"
                placeholder="••••••••"
              />

              <button
                type="button"
                onClick={() => setShowCurrentPassword((v) => !v)}
                className="absolute inset-y-0 right-0 flex items-center px-3 text-neutral-500 hover:text-neutral-700"
                aria-label={
                  showCurrentPassword
                    ? "Ocultar contraseña actual"
                    : "Mostrar contraseña actual"
                }
              >
                {showCurrentPassword ? <EyeOpenIcon /> : <EyeOffIcon />}
              </button>
            </div>
          </div>

          {/* New password */}
          <div>
            <label className="block text-sm font-medium text-neutral-700 mb-2">
              Nueva Contraseña *
            </label>

            <div className="relative">
              <input
                type={showNewPassword ? "text" : "password"}
                value={formData.newPassword}
                onChange={(e) =>
                  onFormChange({ ...formData, newPassword: e.target.value })
                }
                required
                minLength={8}
                className="input-field pr-12"
                placeholder="••••••••"
              />

              <button
                type="button"
                onClick={() => setShowNewPassword((v) => !v)}
                className="absolute inset-y-0 right-0 flex items-center px-3 text-neutral-500 hover:text-neutral-700"
                aria-label={
                  showNewPassword
                    ? "Ocultar nueva contraseña"
                    : "Mostrar nueva contraseña"
                }
              >
                {showNewPassword ? <EyeOpenIcon /> : <EyeOffIcon />}
              </button>
            </div>

            <p className="text-xs text-neutral-500 mt-1">Mínimo 8 caracteres</p>
          </div>

          {/* Confirm password */}
          <div>
            <label className="block text-sm font-medium text-neutral-700 mb-2">
              Confirmar Nueva Contraseña *
            </label>

            <div className="relative">
              <input
                type={showConfirmPassword ? "text" : "password"}
                value={formData.confirmPassword}
                onChange={(e) =>
                  onFormChange({ ...formData, confirmPassword: e.target.value })
                }
                required
                minLength={8}
                className="input-field pr-12"
                placeholder="••••••••"
              />

              <button
                type="button"
                onClick={() => setShowConfirmPassword((v) => !v)}
                className="absolute inset-y-0 right-0 flex items-center px-3 text-neutral-500 hover:text-neutral-700"
                aria-label={
                  showConfirmPassword
                    ? "Ocultar confirmación de contraseña"
                    : "Mostrar confirmación de contraseña"
                }
              >
                {showConfirmPassword ? <EyeOpenIcon /> : <EyeOffIcon />}
              </button>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 pt-4">
            <button type="button" onClick={onClose} 
                className="w-full sm:flex-1 btn-secondary py-3 sm:py-2.5 text-base"
>
              Cancelar
            </button>
            <button type="submit" 
             className="w-full sm:flex-1 btn-primary py-3 sm:py-2.5 text-base">
              Cambiar Contraseña
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PasswordChangeModal;
